import { Box, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'
import ChildNoValueCell from 'components/DataGrid/ChildRows/ChildNoValueCell'

interface WebsiteCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const formatWebsite = url => {
  return url
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .replace(/\/$/, '')
}
const WebsiteCell: FC<WebsiteCellProps> = ({ params, densityStyles }) => {
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  if (!params?.row?.isParent) return <ChildNoValueCell densityStyles={densityStyles} />
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
        height: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      {params && params.value ? (
        <a
          href={params.value.startsWith('http') ? params.value : `https://${params.value}`}
          onClick={e => e.stopPropagation()}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit', overflow: 'hidden', textOverflow: 'ellipsis' }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'left',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              gap: 1,
            }}
          >
            <Typography sx={{ fontSize: densityStyles.fontSize, overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {formatWebsite(params.value)}
            </Typography>
          </Box>
        </a>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'left', overflow: 'hidden', textOverflow: 'ellipsis', gap: 1 }}>
          <Typography
            sx={{
              fontSize: densityStyles.fontSize,
              color: 'rgb(84, 81, 81)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {'No Website'}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
export default WebsiteCell
